import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AppManageService } from '../../../services/app-manage.service';

@Component({
  selector: 'app-register-complete',
  templateUrl: './register-complete.component.html',
})
export class RegisterCompleteComponent {
  constructor(
    private _route: ActivatedRoute,
    private _redirectRoute: Router,
    private _appManageService: AppManageService,
  ) {}

  ngOnInit(): void {
    this._route.queryParamMap.subscribe((query: any) => {
      const url = window.location.href;
      this._appManageService.detectarDispositivo(url);

      if (Object.keys(query.params).length) {
        localStorage.setItem(
          'idRegisterComplete',
          JSON.stringify(query.params),
        );
        this._redirectRoute.navigate(['auth/login']);
      }
    });
  }
}
